// extracted by mini-css-extract-plugin
module.exports = {"Container":"SwitchButton_Container__26IA3","Buttons":"SwitchButton_Buttons__3sh-e","Button":"SwitchButton_Button__3ki_G","Active":"SwitchButton_Active__1zXVI"};